/* grid.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbgBM8%7Bdisplay%3Agrid%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._17lj8pPgdg%7B-moz-column-gap%3Avar(--ds-space-0%2C0)%3Bcolumn-gap%3Avar(--ds-space-0%2C0)%7D%0A._17lj8pFQfX%7B-moz-column-gap%3Avar(--ds-space-025%2C2px)%3Bcolumn-gap%3Avar(--ds-space-025%2C2px)%7D%0A._17lj8p1Y8M%7B-moz-column-gap%3Avar(--ds-space-050%2C4px)%3Bcolumn-gap%3Avar(--ds-space-050%2C4px)%7D%0A._17lj8pgVvo%7B-moz-column-gap%3Avar(--ds-space-075%2C6px)%3Bcolumn-gap%3Avar(--ds-space-075%2C6px)%7D%0A._17lj8p2ADO%7B-moz-column-gap%3Avar(--ds-space-100%2C8px)%3Bcolumn-gap%3Avar(--ds-space-100%2C8px)%7D%0A._17lj8p8HPE%7B-moz-column-gap%3Avar(--ds-space-150%2C9pt)%3Bcolumn-gap%3Avar(--ds-space-150%2C9pt)%7D%0A._17lj8p5zaO%7B-moz-column-gap%3Avar(--ds-space-200%2C1pc)%3Bcolumn-gap%3Avar(--ds-space-200%2C1pc)%7D%0A._17lj8pkG2W%7B-moz-column-gap%3Avar(--ds-space-250%2C20px)%3Bcolumn-gap%3Avar(--ds-space-250%2C20px)%7D%0A._17lj8pNHnM%7B-moz-column-gap%3Avar(--ds-space-300%2C24px)%3Bcolumn-gap%3Avar(--ds-space-300%2C24px)%7D%0A._17lj8pVa5s%7B-moz-column-gap%3Avar(--ds-space-400%2C2pc)%3Bcolumn-gap%3Avar(--ds-space-400%2C2pc)%7D%0A._17lj8pS40j%7B-moz-column-gap%3Avar(--ds-space-500%2C40px)%3Bcolumn-gap%3Avar(--ds-space-500%2C40px)%7D%0A._17lj8pp0Oa%7B-moz-column-gap%3Avar(--ds-space-600%2C3pc)%3Bcolumn-gap%3Avar(--ds-space-600%2C3pc)%7D%0A._17lj8pGXk2%7B-moz-column-gap%3Avar(--ds-space-800%2C4pc)%3Bcolumn-gap%3Avar(--ds-space-800%2C4pc)%7D%0A._17lj8pyFLW%7B-moz-column-gap%3Avar(--ds-space-1000%2C5pc)%3Bcolumn-gap%3Avar(--ds-space-1000%2C5pc)%7D%0A._17lj8pjV64%7B-moz-column-gap%3Avar(--ds-space-gap-xxsmall%2C2px)%3Bcolumn-gap%3Avar(--ds-space-gap-xxsmall%2C2px)%7D%0A._17lj8pUCGe%7B-moz-column-gap%3Avar(--ds-space-gap-xsmall%2C4px)%3Bcolumn-gap%3Avar(--ds-space-gap-xsmall%2C4px)%7D%0A._17lj8pA6HX%7B-moz-column-gap%3Avar(--ds-space-gap-small%2C6px)%3Bcolumn-gap%3Avar(--ds-space-gap-small%2C6px)%7D%0A._17lj8p1Tnb%7B-moz-column-gap%3Avar(--ds-space-gap-medium%2C8px)%3Bcolumn-gap%3Avar(--ds-space-gap-medium%2C8px)%7D%0A._17lj8phS5a%7B-moz-column-gap%3Avar(--ds-space-gap-large%2C9pt)%3Bcolumn-gap%3Avar(--ds-space-gap-large%2C9pt)%7D%0A._17lj8pK6kw%7B-moz-column-gap%3Avar(--ds-space-gap-xlarge%2C1pc)%3Bcolumn-gap%3Avar(--ds-space-gap-xlarge%2C1pc)%7D%0A._17lj8p2H2T%7B-moz-column-gap%3Avar(--ds-space-gap-xxlarge%2C24px)%3Bcolumn-gap%3Avar(--ds-space-gap-xxlarge%2C24px)%7D%0A._42d1HAPgdg%7Brow-gap%3Avar(--ds-space-0%2C0)%7D%0A._42d1HAFQfX%7Brow-gap%3Avar(--ds-space-025%2C2px)%7D%0A._42d1HA1Y8M%7Brow-gap%3Avar(--ds-space-050%2C4px)%7D%0A._42d1HAgVvo%7Brow-gap%3Avar(--ds-space-075%2C6px)%7D%0A._42d1HA2ADO%7Brow-gap%3Avar(--ds-space-100%2C8px)%7D%0A._42d1HA8HPE%7Brow-gap%3Avar(--ds-space-150%2C9pt)%7D%0A._42d1HA5zaO%7Brow-gap%3Avar(--ds-space-200%2C1pc)%7D%0A._42d1HAkG2W%7Brow-gap%3Avar(--ds-space-250%2C20px)%7D%0A._42d1HANHnM%7Brow-gap%3Avar(--ds-space-300%2C24px)%7D%0A._42d1HAVa5s%7Brow-gap%3Avar(--ds-space-400%2C2pc)%7D%0A._42d1HAS40j%7Brow-gap%3Avar(--ds-space-500%2C40px)%7D%0A._42d1HAp0Oa%7Brow-gap%3Avar(--ds-space-600%2C3pc)%7D%0A._42d1HAGXk2%7Brow-gap%3Avar(--ds-space-800%2C4pc)%7D%0A._42d1HAyFLW%7Brow-gap%3Avar(--ds-space-1000%2C5pc)%7D%0A._42d1HAjV64%7Brow-gap%3Avar(--ds-space-gap-xxsmall%2C2px)%7D%0A._42d1HAUCGe%7Brow-gap%3Avar(--ds-space-gap-xsmall%2C4px)%7D%0A._42d1HAA6HX%7Brow-gap%3Avar(--ds-space-gap-small%2C6px)%7D%0A._42d1HA1Tnb%7Brow-gap%3Avar(--ds-space-gap-medium%2C8px)%7D%0A._42d1HAhS5a%7Brow-gap%3Avar(--ds-space-gap-large%2C9pt)%7D%0A._42d1HAK6kw%7Brow-gap%3Avar(--ds-space-gap-xlarge%2C1pc)%7D%0A._42d1HA2H2T%7Brow-gap%3Avar(--ds-space-gap-xxlarge%2C24px)%7D%0A._0hPCNL7p2s%7Balign-items%3Astart%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._0hPCNLQame%7Balign-items%3Abaseline%7D%0A._0hPCNLF05b%7Balign-items%3Aend%7D%0A._0hPCNLFlnN%7Balign-items%3Astretch%7D%0A._0GwItX7p2s%7Balign-content%3Astart%7D%0A._0GwItXDIqT%7Balign-content%3Acenter%7D%0A._0GwItXF05b%7Balign-content%3Aend%7D%0A._0GwItXI7V3%7Balign-content%3Aspace-between%7D%0A._0GwItXxEoi%7Balign-content%3Aspace-around%7D%0A._0GwItXZHm0%7Balign-content%3Aspace-evenly%7D%0A._0GwItXFlnN%7Balign-content%3Astretch%7D%0A._37wbyu7p2s%7Bjustify-content%3Astart%7D%0A._37wbyuDIqT%7Bjustify-content%3Acenter%7D%0A._37wbyuF05b%7Bjustify-content%3Aend%7D%0A._37wbyuI7V3%7Bjustify-content%3Aspace-between%7D%0A._37wbyuxEoi%7Bjustify-content%3Aspace-around%7D%0A._37wbyuZHm0%7Bjustify-content%3Aspace-evenly%7D%0A._37wbyuFlnN%7Bjustify-content%3Astretch%7D%0A._293iXK1qpb%7Bgrid-auto-flow%3Arow%7D%0A._293iXKbt8w%7Bgrid-auto-flow%3Acolumn%7D%0A._293iXKrVq7%7Bgrid-auto-flow%3Adense%7D%0A._293iXKb2Fs%7Bgrid-auto-flow%3Arow%20dense%7D%0A._293iXKs8QB%7Bgrid-auto-flow%3Acolumn%20dense%7D");



































































import { type ElementType, forwardRef, type ForwardRefExoticComponent, memo, type MemoExoticComponent, type ReactNode, type Ref, type RefAttributes } from 'react';
import type { AlignContent, AlignItems, AutoFlow, BasePrimitiveProps, GapToken, JustifyContent, JustifyItems } from './types';
export type GridProps<T extends ElementType = 'div'> = {
  /**
   * The DOM element to render as the Flex. Defaults to `div`.
   */
  as?: 'div' | 'span' | 'ul' | 'ol';

  /**
   * Used to align children along the inline axis.
   */
  justifyContent?: JustifyContent;

  /**
   * Used to align the grid along the inline axis.
   *
   * @deprecated This prop is not hooked up and doesn't nothing!
   */
  justifyItems?: JustifyItems;

  /**
   * Used to align children along the block axis.
   */
  alignItems?: AlignItems;

  /**
   * Used to align the grid along the block axis.
   */
  alignContent?: AlignContent;

  /**
   * Represents the space between each column.
   */
  columnGap?: GapToken;

  /**
   * Represents the space between each child across both axes.
   */
  gap?: GapToken;

  /**
   * Represents the space between each row.
   */
  rowGap?: GapToken;

  /**
   * Specifies how auto-placed items get flowed into the grid. CSS `grid-auto-flow`.
   */
  autoFlow?: AutoFlow;

  /**
   * Elements to be rendered inside the grid. Required as a grid without children should not be a grid.
   */
  children: ReactNode;

  /**
   * HTML id attrubute.
   */
  id?: string;

  /**
   * Forwarded ref element.
   */
  ref?: React.ComponentPropsWithRef<T>['ref'];
} & BasePrimitiveProps;
const rowGapMap = {
  'space.0': "_42d1HAPgdg",
  'space.025': "_42d1HAFQfX",
  'space.050': "_42d1HA1Y8M",
  'space.075': "_42d1HAgVvo",
  'space.100': "_42d1HA2ADO",
  'space.150': "_42d1HA8HPE",
  'space.200': "_42d1HA5zaO",
  'space.250': "_42d1HAkG2W",
  'space.300': "_42d1HANHnM",
  'space.400': "_42d1HAVa5s",
  'space.500': "_42d1HAS40j",
  'space.600': "_42d1HAp0Oa",
  'space.800': "_42d1HAGXk2",
  'space.1000': "_42d1HAyFLW",
  'space.gap.xxsmall': "_42d1HAjV64",
  'space.gap.xsmall': "_42d1HAUCGe",
  'space.gap.small': "_42d1HAA6HX",
  'space.gap.medium': "_42d1HA1Tnb",
  'space.gap.large': "_42d1HAhS5a",
  'space.gap.xlarge': "_42d1HAK6kw",
  'space.gap.xxlarge': "_42d1HA2H2T"
};
const columnGapMap = {
  'space.0': "_17lj8pPgdg",
  'space.025': "_17lj8pFQfX",
  'space.050': "_17lj8p1Y8M",
  'space.075': "_17lj8pgVvo",
  'space.100': "_17lj8p2ADO",
  'space.150': "_17lj8p8HPE",
  'space.200': "_17lj8p5zaO",
  'space.250': "_17lj8pkG2W",
  'space.300': "_17lj8pNHnM",
  'space.400': "_17lj8pVa5s",
  'space.500': "_17lj8pS40j",
  'space.600': "_17lj8pp0Oa",
  'space.800': "_17lj8pGXk2",
  'space.1000': "_17lj8pyFLW",
  'space.gap.xxsmall': "_17lj8pjV64",
  'space.gap.xsmall': "_17lj8pUCGe",
  'space.gap.small': "_17lj8pA6HX",
  'space.gap.medium': "_17lj8p1Tnb",
  'space.gap.large': "_17lj8phS5a",
  'space.gap.xlarge': "_17lj8pK6kw",
  'space.gap.xxlarge': "_17lj8p2H2T"
};
const justifyContentMap = {
  start: "_37wbyu7p2s",
  center: "_37wbyuDIqT",
  end: "_37wbyuF05b",
  'space-between': "_37wbyuI7V3",
  'space-around': "_37wbyuxEoi",
  'space-evenly': "_37wbyuZHm0",
  stretch: "_37wbyuFlnN"
};
const alignContentMap = {
  start: "_0GwItX7p2s",
  center: "_0GwItXDIqT",
  end: "_0GwItXF05b",
  'space-between': "_0GwItXI7V3",
  'space-around': "_0GwItXxEoi",
  'space-evenly': "_0GwItXZHm0",
  stretch: "_0GwItXFlnN"
};
const alignItemsMap = {
  start: "_0hPCNL7p2s",
  center: "_0hPCNLDIqT",
  baseline: "_0hPCNLQame",
  end: "_0hPCNLF05b",
  stretch: "_0hPCNLFlnN"
};
const baseStyles = {
  root: "_3iDTPbgBM8 _24h04i2Njc"
};
const gridAutoFlowMap = {
  row: "_293iXK1qpb",
  column: "_293iXKbt8w",
  dense: "_293iXKrVq7",
  'row dense': "_293iXKb2Fs",
  'column dense': "_293iXKs8QB"
};

/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Box } from '@atlaskit/primitives/compiled'
 * import { Grid } from '@atlaskit/primitives/compiled/grid'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */
export const Grid: MemoExoticComponent<ForwardRefExoticComponent<Omit<GridProps<ElementType>, 'ref'> & RefAttributes<any>>> = memo(forwardRef(<T extends ElementType = 'div',>({
  as,
  alignItems,
  alignContent,
  justifyContent,
  gap,
  columnGap,
  rowGap,
  children,
  id,
  role,
  testId,
  autoFlow,
  xcss
}: GridProps<T>, ref: Ref<any>) => {
  const Component = as || 'div';
  return <Component id={id} role={role} className={ax([baseStyles.root, gap && columnGapMap[gap], columnGap && columnGapMap[columnGap], gap && rowGapMap[gap], rowGap && rowGapMap[rowGap], alignItems && alignItemsMap[alignItems], alignContent && alignContentMap[alignContent], justifyContent && justifyContentMap[justifyContent], autoFlow && gridAutoFlowMap[autoFlow], xcss])} data-testid={testId} ref={ref}>
					{children}
				</Component>;
}));
Grid.displayName = 'Grid';